__webpack_require__.p = "/wp-content/themes/weavr_theme/dist/";